module.exports = __webpack_public_path__ + "img/VL_07_02.2a78a6e6.png";